import moment from "moment";
import { useEffect, useRef, useState } from "react";
import MessageParseService from "../services/messageParseService";
import Audio from "./Audio";
import EmptyState from "./EmptyState";
import { ReportService } from "../services/reportService";

declare const bootstrap: any;

export default function ChatMessages({ chat, show, onRequestClose }) {

  const domRef = useRef<HTMLInputElement>(null);
  const [offcanvas, setOffcanvas] = useState<any>();
  const containerRef = useRef<HTMLInputElement>(null);
  const listChatContainerRef = useRef<HTMLInputElement>(null);
  const [mainHeight, setMainHeight] = useState<any>(0);
  const [messages, setMessages] = useState([])

  const messageParse = MessageParseService.getInstance();

  const hide = () => {
    offcanvas.hide();
  };

  const scrollToBottom = () => {
    setTimeout(() => listChatContainerRef.current.scrollIntoView(), 100);
  };

  const getMessages = async() => {
    const $messages = await ReportService.getMessagesByChat(chat._id);
    setMessages($messages);
  }

  useEffect(() => {
    if (chat) {
      getMessages();
    }
  }, [chat]);

  useEffect(() => {
    if (show) {
      offcanvas.show();
    }
  }, [show]);

  useEffect(() => {
    if (domRef.current) {
      const offcanvasInstance = new bootstrap.Offcanvas(domRef.current, {
        // backdrop: false,
        keyboard: false,
        // scroll: true,
      });

      domRef.current.addEventListener("hidden.bs.offcanvas", function () {
        onRequestClose();
        // setIdSelected(null);
      });

      setOffcanvas(offcanvasInstance);
    }
  }, []);

  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        
        setMainHeight(
          containerRef.current.clientHeight 
        );
      }
    };

    updateSize();

    window.addEventListener("resize", updateSize);

    return () => window.removeEventListener("resize", updateSize);
  }, [containerRef.current]);

  return (
    <div
      className="offcanvas offcanvas-end offcanvas-projecter"
      tabIndex={-1}
      id="offcanvasRight"
      aria-labelledby="offcanvasRightLabel"
      ref={domRef}
    >
      <div className="offcanvas-header border-botton">
        <div className="bg-white d-flex align-items-center w-full">

            <span className="avatar avatar-primary avatar-circle">
                <img className="avatar-img w-100" src={chat?.contact?.avatar} alt={`${chat?.contact?.first_name} ${chat?.contact?.last_name}`} />
            </span>
            <div className="px-2 flex-grow-1 d-flex ">
                <div className="flex-grow-1">
                    <h4 className="mb-0 font-16">{chat?.contact?.first_name} {chat?.contact?.last_name}</h4>
                    <p>{chat?.number}</p>
                </div>
            </div>
            { chat?.contact?.opt_in_accepted &&  <span className="badge bg-soft-primary text-primary ms-2">Opt-In Otorgado</span>}
            { !chat?.contact?.opt_in_accepted &&  <span className="badge bg-soft-danger text-dark ms-2">Opt-In No otorgado</span>}
            <button type="button" className="btn-close" onClick={hide}></button>
        </div>
        
      </div>
      <div
        className={`offcanvas-body p-0`}
        style={{ overflow: "hidden" }}
        ref={containerRef}
      >
        <div
          className="row g-0"
          style={{ height: `${mainHeight}px`, overflow: "hidden" }}
        >
          <div className="col-12 messages h-100-scroll">
            <div className="messages-container">
              {messages.length === 0 && (
                <div className="p-5">
                  <EmptyState
                    title=""
                    text="Selecciona un chat para ver los mensajes."
                  />
                </div>
              )}

              {messages.map((message, index) => {
                if (index === messages.length - 1) {
                  scrollToBottom();
                }

                return (
                  <div
                    className={`message-item ${
                      message.type === "OUTBOUND" ? "" : "left"
                    } ${message.format === "STICKER" ? "sticker" : ""}`}
                    key={message._id}
                  >
                    {(message.format === "TEXT" ||
                      message.format === "CONTENT_REPOSITORY") && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: messageParse.parseTxt(message.message),
                        }}
                      />
                    )}
                    {message.format === "IMAGE" && (
                      <div>
                        <div className="d-flex message-multimedia">
                          <div className="icon">
                            <i className="bi bi-camera-fill"></i>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            <h6>Imagen recibido</h6>
                            <button className="btn-link">Ver imagen</button>
                          </div>
                        </div>
                        {message.message && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: messageParse.parseTxt(message.message),
                            }}
                          />
                        )}
                      </div>
                    )}
                    {message.format === "VIDEO" && (
                      <div>
                        <div className="d-flex message-multimedia">
                          <div className="icon">
                            <i className="bi bi-camera-video-fill"></i>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            <h6>Video recibido</h6>
                            <button className="btn-link">Ver video</button>
                          </div>
                        </div>
                        {message.message && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: messageParse.parseTxt(message.message),
                            }}
                          />
                        )}
                      </div>
                    )}
                    {message.format === "DOCUMENT" && (
                      <div>
                        <div className="d-flex message-multimedia">
                          <div className="icon">
                            <i className="bi bi-file-earmark-fill"></i>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            <h6>{message.message}</h6>
                            <button className="btn-link">
                              Descargar archivo
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    {message.format === "AUDIO" && (
                      <div>
                        <Audio />
                      </div>
                    )}
                    {message.format === "LOCATION" && (
                      <div>
                        <div className="">
                          <iframe
                            src={`https://maps.google.com/maps?q=${message.format_detail.latitude},${message.format_detail.longitude}&hl=es;z=10&output=embed`}
                            width="100%"
                            height="200"
                            loading="lazy"
                            allowFullScreen
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Location"
                          ></iframe>
                        </div>
                      </div>
                    )}
                    {message.format === "STICKER" && (
                      <div className="message-multimedia sticker">
                        <img src={message.format_detail.url} alt="Sticker" />
                      </div>
                    )}

                    <p>{moment(message.created_at).format("DD/MM/YY HH:mm")}</p>
                  </div>
                );
              })}
            </div>
            <div ref={listChatContainerRef}></div>
          </div>
        </div>
      </div>
    </div>
  );
}
